// import styled from 'styled-components';

/* types */

/* components */
import { Tooltip as MuiTooltip, TooltipProps as MuiTooltipProps, tooltipClasses } from "@mui/material";
import { styled } from "@mui/material/styles";
import { CustomTooltipProps } from "../types";

// export const StyledTooltip = styled(MuiTooltip)<CustomTooltipProps>``;


export const StyledTooltip = styled(MuiTooltip, {
  shouldForwardProp: (prop) => !['color'].includes(String(prop)),
})<CustomTooltipProps>(({ theme, color, }) => ({
  // border: `1px solid red`,
  // '.MuiTooltip-tooltip': {
  // },
  //
  // [`& .${tooltipClasses.tooltip}`]: {
  //   backgroundColor: theme.palette.error[600],
  //   // color: 'rgba(0, 0, 0, 0.87)',
  //   // boxShadow: theme.shadows[1],
  //   fontSize: 11,
  //
  //   ...(color === `default` && { backgroundColor: theme.palette.grayscaleSecondary[400] }),
  //   ...(color === `primary` && { backgroundColor: theme.palette.primary.main }),
  //   ...(color === `secondary` && { backgroundColor: theme.palette.secondary.main }),
  //   ...(color === `error` && { backgroundColor: theme.palette.error.main }),
  //   ...(color === `info` && { backgroundColor: theme.palette.info.main }),
  //   ...(color === `success` && { backgroundColor: theme.palette.success.main }),
  //   ...(color === `warning` && { backgroundColor: theme.palette.warning.main }),
  //   ...(color === `grayscale` && {backgroundColor: theme.palette.grayscale.main}),
  //   // ...(color && { backgroundColor: theme.palette[color][400]}),
  // },

}));
